module.exports = __webpack_public_path__ + "media/icons/widget-close@3x-199eb859.svg";